import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const AuthenticationQueryKeyStore = createQueryKeyStore({
    authentication_login: null,
    authentication_logout: null,
});
